module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<th class="c">Choice</th>\n\n<th class="new">\n  <span class="icon icon-plus add_address">+</span>\n</th>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./menupicker/templates/header.html
// module id = 269
// module chunks = 0